import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../ui/AlertDialog/AlertDialog";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../../hooks/useFetch";
import { Button } from "../../../ui/Button";
import { useAppStore } from "../../../stores/RootStore";
import { useNavigate, useOutletContext } from "react-router-dom";
import { UserCompact } from "../../../types/types";

type Props = {
  id: string;
  isDeleteOpen: boolean;
  closeModal: Function;
};

const DeleteUser = ({ id, isDeleteOpen, closeModal }: Props) => {
  const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] = useFetch(
    `/users/${id}`
  );

const [users, setUsers] = useOutletContext<[UserCompact[], Function]>();

  const deleteItem = () => {
    setUsers(users?.filter((user) => user.id != id)!);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (deleteResponse) {
      deleteItem();
      navigate("..", { relative: "path" });
      closeModal();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить участника</AlertDialogTitle>
        <AlertDialogDescription>Вы уверены, что хотите удалить участника?</AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteUser;
